export const POST_INPUT_SUBTEXT = 'What’s on your mind?';
export const POST_INPUT_LENGTH_WARNING = 'You have exceeded the maximum character limit -';
export const POST_INPUT_PLACEHOLDER = 'Add a question or just start a discussion';
export const SUBMIT_POST = 'Submit';
export const CANCEL_POST_SUBMISSION = 'Cancel';

export const GENERAL_ERROR_WARNING = 'Ups… Something went wrong!';

export const ACCESS_TOKEN_KEY = 'TCG-CommunityPortal-User';
export const PREVIOUSLY_VIEWED_POSTS_KEY = 'previouslyViewedPosts';
export const SORTING_KEY = 'sort';
